import React from 'react'
import { textcss } from '../../../common/CSS'

export function TextArea(props) {
  let { className, inputcln, type, label, value, name, placeholder, onKeyPress, onBlurHandler = () => { }, onChangeHandler, errorMessage, required, errors } = props


  return (
    <div className={`px-1 pt-1 mt-2 ${className} `}>
      <label className="block border-b-2">
        <p className={textcss?.labelClass}> {label} {required && <span>*</span>} </p>
        <textarea autoComplete='off' type={type} required={required} className={`${textcss.inputClass} ${inputcln} resize-none `} value={value} name={name} onKeyPress={onKeyPress} onChange={(event) => { onChangeHandler(event, errorMessage) }} onBlur={(event) => { onBlurHandler(event, errorMessage) }} placeholder={placeholder} />
      </label>
      {errors?.[name] && <span className="text-scogoRed text-base font-normal">{errors[name]}</span>}
    </div>
  )
}
